import React from 'react';
import StudentDetails from './StudentDetails';
import ChargesSummary from './ChargesSummary';
import ExamDetails from './examDetails';
import { useGetExamChargesContext } from '../context';
import ALoader from '../../../common/a-loader';

const ExamChargesDetails = () => {
    const { landingPageDataLoading } = useGetExamChargesContext();
    return (
        <>
            {landingPageDataLoading && <ALoader position={"fixed"} />}
            <StudentDetails />
            <ExamDetails />
            <ChargesSummary />
        </>
    );
}

export default ExamChargesDetails;